import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import { connect } from 'react-redux';
import Article from 'grommet/components/Article';
import CheckBox from 'grommet/components/CheckBox';
import FormField from 'grommet/components/FormField';
import TextInput from 'grommet/components/TextInput';
import Form from 'grommet/components/Form';
import Select from 'grommet/components/Select';
import CircleInformation from 'grommet/components/icons/base/CircleInformation';
import Paragraph from 'grommet/components/Paragraph';
import { fetchActiveList } from '../Redux/actions/epaActions';
import { fetchFilteredComps } from '../Redux/actions/epaActions';
import { toggleSizeButton } from '../../State/actions/sessions';
import ReactTooltip from 'react-tooltip';
import { fetchSupportedList } from '../Redux/actions/epaActions';
import * as Constants from '../Redux/action_types/EPAConstants.js';
import Warning from './Warning';
import { updateFinishButton } from '../commonLogic';

var iLOText = [];
var Networktext = [];
var FactoryExpresstext = [];
var GetAllSupportedComponents;
let NetworkSpeedList = [];
let AdditionalSwitches = [];
let FactoryExpressList = [];
let MellanoxList=[]
let displayStorageNetworkSpeed = false;

class DesignRequirements extends Component {

    constructor() {
        super();
        this.state = {
            PrefereedRackhgtList: [],
            preferedRacksListObj: '',
            preferedRacksList: [],
            informationicon: false,
        };
        this.HWSupportChange = this.HWSupportChange.bind(this);
        this.LinuxLicenceChange = this.LinuxLicenceChange.bind(this);
        this.HadoopLicenseChage = this.HadoopLicenseChage.bind(this);
        this.iLO_CMULicenseChage = this.iLO_CMULicenseChage.bind(this);
        this.NetworkSpeedChage = this.NetworkSpeedChage.bind(this);
        this.NetworkSwitchChage = this.NetworkSwitchChage.bind(this);
        this.FactoryExpressChage = this.FactoryExpressChage.bind(this);
        this.AdditionalSwitchChange = this.AdditionalSwitchChange.bind(this);
        this.MaxPowerPerRack = this.MaxPowerPerRack.bind(this);
        this.maxWeightPerRack = this.maxWeightPerRack.bind(this);
        this.onRackHeightChange = this.onRackHeightChange.bind(this);
        this.onRackListChange = this.onRackListChange.bind(this);
        this.RackDetails = this.RackDetails.bind(this);
        this.ConsolidateChassisChange = this.ConsolidateChassisChange.bind(this)
        this.AddtnlNtwkSwtchChage = this.AddtnlNtwkSwtchChage.bind(this);
        


    }
    componentWillMount() {



    }
    NetworkSwitchChage(e) {

    }
    RackDetails() {

        if (this.state.PrefereedRackhgtList.length === 0) {
            this.props.DefaultSolution.Racks.Rack.map((v) => {
                this.state.PrefereedRackhgtList.push(v["@Height"])
                //this.state.PrefereedRackhgtList=[...this.state.PrefereedRackhgtList,v["@Height"]];       
            })
            // this.state.preferedRacksListObj= this.props.DefaultSolution.Racks.Rack.filter(x=>x["@Height"] ===this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Rack);               
            this.props.DefaultSolution.Racks.Rack.map((x) => {
                if (x["@Height"] === this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Rack) {
                    if (Array.isArray(x.RackItem.Item)) {
                        x.RackItem.Item.map((rack) => {
                            this.state.preferedRacksList.push(rack['#text'])
                        })
                    } else {
                        this.state.preferedRacksList.push(x.RackItem.Item['#text'])
                    }

                }
            });
        }

    }
    componentDidMount() {
        NetworkSpeedList = this.props.DefaultSolution.Services.NetworkSpeed.Item
        //NetworkSwitchList=DefaultSolution.Services.NetworkSpeed.Item;

        if (this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
            FactoryExpressList = this.props.DefaultSolution.FactoryExpress.Item;
        } else {
            FactoryExpressList = ["No Factory Express"]
        }

        if(this.props.DefaultSolution.NwSwitches.Mellanox !== undefined){
            MellanoxList=this.props.DefaultSolution.NwSwitches.Mellanox.Item
        }


        if (this.props.workload.UserInputs.Environments.WorkloadType === 'BigData') {
            if (!this.props.activeSession.isSizeEnabled)
                this.props.OnToggleSizeButton(true);
        }
        else {
            displayStorageNetworkSpeed = false;
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.StorageNetworkSpeed["@isSelected"] = Constants.nO_;
            let selectedServices = this.props.workload.UserInputs.Environments.Environment.filter(solution => solution["@isSelected"] === Constants.yES_);
            if (selectedServices.length > 0) {
                selectedServices.map(service => {
                    if (service.StorageValue.isCalculated === Constants.tRUE_) {
                        displayStorageNetworkSpeed = true;
                        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.StorageNetworkSpeed["@isSelected"] = Constants.yES_;
                    }
                })
            }
            var NoValues = true
            this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@isCurrentTab"] === "yes").Templates.Template.filter((x, id) => {
                if (x["@Type"] !== "Custom" && x["@Type"] !== "Custom w/GPUs") {
                    if (parseInt(x.Nodes["@vClusters"], 10) !== 0 && parseInt(x.Nodes["@vNodesPerCluster"], 10) !== 0) {
                        NoValues = false
                    }

                } else {
                    if (parseInt(x.Nodes["@vClusters"], 10) !== 0 && parseInt(x.Nodes["@vNodesPerCluster"], 10) !== 0 && parseInt(x.Nodes["@vCPUPerNode"], 10) !== 0 &&
                        parseInt(x.Nodes["@vMemoryPerNode"], 10) !== 0 && parseInt(x.Nodes["@StoragePervNode"], 10) !== 0) {
                        NoValues = false
                    }

                }
            })
            if (updateFinishButton(this.props.workload, this.props.displayWarning, this.props.activeSession.isSizeEnabled)) {
                this.props.OnToggleSizeButton(true);
            }
        }
        this.setState({});
    }

    onRackHeightChange(e) {
        this.state.preferedRacksList = [];
        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Rack = e.value;
        this.state.preferedRacksListObj = this.props.DefaultSolution.Racks.Rack.filter(x => x["@Height"] == this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Rack);
        console.log(this.state.preferedRacksList);
        this.state.preferedRacksListObj.map((rack) => {
            console.log(this.state.preferedRacksListObj["@Height"])
            if (rack['@Height'] === this.state.preferedRacksListObj[0]["@Height"]) {
                if (Array.isArray(rack.RackItem.Item)) {
                    rack.RackItem.Item.map((val) => {
                        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.RackDescription = val['#text'];
                        this.state.preferedRacksList = [...this.state.preferedRacksList, val['#text']];
                    });
                } else {
                    this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.RackDescription = rack.RackItem.Item['#text'];
                    this.state.preferedRacksList = [...this.state.preferedRacksList, rack.RackItem.Item['#text']];
                }
            }


        })
        this.setState({});
    }
    onRackListChange(e) {
        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.RackDescription = e.value;
        this.setState({})
    }
    MaxPowerPerRack(e) {
        if (e.target.value.length <= 5) {
            var x = parseInt(e.target.value, 10);
            if (isNaN(x)) {
                this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower = " "
            }
            else if (x > 20001) {
                this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower = x.toString();
            }
            else {
                this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower = x.toString();
            }
            this.setState({});
        } else {
        }
    }
    MaxPowerPerRackBlur(e) {
        var x = parseInt(e.target.value, 10);
        if (isNaN(x) || e.target.value == "" || e.target.value == "  ") {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower = "2000"
        } else if (x < 2000) {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower = "2000"
        } else if (x > 20000) {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower = "20000"
        } else {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower = x.toString();
        }
        this.setState({});
    }
    onNumberOfSwitchesChage(e){
        if (e.target.value.length <= 2) {
            var x = parseInt(e.target.value, 10);
            if (isNaN(x)) {
               this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"] = " "
            }
            else if (x > 9) {
               this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"] = "9".toString();
            }
            else {
                this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"] = x.toString();
            }
            this.setState({});
        } else {
        }
    }
     onNumberOfSwitchesBlur(e) {
        var x = parseInt(e.target.value, 10);
        if (isNaN(x) || e.target.value == "" || e.target.value == "  ") {
           this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"] = "1"
        }else if (x > 9) {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"] = "9"
        } 
        /* Change by Vinay, checking negative value */
        else if (x <= 0 ){
           this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"] = "1".toString();
        }else{
          this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"] = x.toString();  
        }
        this.setState({});
    }
    maxWeightPerRack(e) {
        if (e.target.value.length <= 4) {
            var x = parseInt(e.target.value, 10);
            if (isNaN(x)) {
                this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight = " "
            }
            else if (x > 5000) {
                this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight = x.toString();
            }
            else {
                this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight = x.toString();
            }
            this.setState({});
        } else {
        }
    }
    
    maxWeightPerRackBlur(e) {
        var x = parseInt(e.target.value, 10);
        if (isNaN(x) || e.target.value == "" || e.target.value == "  ") {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight = "300"
        } else if (x < 300) {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight = "300"
        } else if (x > 5000) {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight = "5000"
        } else {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight = x.toString();
        }
        this.setState({});
    }


    HWSupportChange(e) {
        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["HWSupport"] = e.value;
        this.setState({});
    }
    LinuxLicenceChange(e) {
        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["LinuxLicense"] = e.value;
        this.setState({});

    }
    HadoopLicenseChage(e) {
        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["HadoopLicense"] = e.value;
        this.setState({});
    }
    iLO_CMULicenseChage(e) {
        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["iLoLicense"] = e.value;
        this.setState({});

    }
    NetworkSpeedChage(e) {
        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSpeed"] = e.value;
        this.setState({});
    }

    StorageNetworkSpeedChange = (e) => {
        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.StorageNetworkSpeed[Constants.TEXT_ATTRIBUTE] = e.value;
        this.setState({});
    }
    FactoryExpressChage(e) {
        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.FactoryExpress = e.value;
        this.setState({});

    }
    AddtnlNtwkSwtchChage(e){
         this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch['#text'] = e.value;
         /*added by Vinay*/         
         this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"] = "1"
        this.setState({});
    }
    ConsolidateChassisChange(e) {
        if (this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis === 'true') {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis = 'false'
        } else {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis = 'true'
        }
        this.setState({});
    }

    onNimbleStorageChange = () => {
        if (this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.CAAS_)["@isSelected"] === Constants.nO_) {
            if (this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble === Constants.tRUE_) {
                this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble = Constants.fALSE_;
            } else {
                this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble = Constants.tRUE_;
            }
            this.props.workload.UserInputs.Environments.NimbleUserChoice = this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble;
            this.setState({});
        }
    }

    AdditionalSwitchChange(e) {
        this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSwitch"] = e.value;
        this.setState({});
    }
    InformationIconClick(e) {
        this.props.Informationicondescription.Text.map((name) => {
            switch (name["@Name"]) {
                case "iLOLicense": {
                    if (e === "informationbuttoniLO") {
                        this.state.content = iLOText.map((val) => <Paragraph margin="none" style={{ padding: '6px' }}>{val}</Paragraph>)

                    }
                    break;
                }
                case "NetworkSpeed": {
                    if (e === "informationbuttonNetworkspeed") {
                        this.state.content = Networktext.map((val) => <Paragraph margin="none" style={{ padding: '6px' }}>{val}</Paragraph>)
                    }

                    break;
                }
                case "FactoryExpress": {
                    if (e === "informationbuttonFactoryExpress") {
                        this.state.content = FactoryExpresstext.map((val) => <Paragraph margin="none" style={{ padding: '6px' }}>{val}</Paragraph>)
                    }
                    break;
                }
            }
        });
        this.setState({ heading: "Information", informationicon: true })

    }
    render() {
        let nimbleStorageChecked = false;
        AdditionalSwitches = []
        var type = '';
        this.props.workload.UserInputs.Environments.WorkloadType === 'BigData' ?
            type = <Select options={['Bare metal']} value='Bare metal' /> : type = <Select options={['HPE Ezmeral' + Constants.RE]} value={Constants.HPE_E_CPDESC} />


        this.RackDetails();
        if (this.props.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
            if (this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.CAAS_)["@isSelected"] === Constants.yES_) {
                this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble = Constants.tRUE_;
            }
            if (this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble === Constants.tRUE_) {
                nimbleStorageChecked = true;
            }
        }
        this.props.DefaultSolution.Services.NetworkSwitches.Item.map((val, id) => {
            AdditionalSwitches.push(val)
            if (val === "HPE Composable Fabric FM" && this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSpeed"] !== "25G" && this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSpeed"] !== "100G") {
                AdditionalSwitches.splice(id, 1)
            }
        })
        if (AdditionalSwitches.indexOf(this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSwitch"]) === -1) {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSwitch"] = AdditionalSwitches[0]
        }

        if (this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis === undefined) {
            this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis='true'
        }
        var ConsolidateChassisValue
        ConsolidateChassisValue=(/true/i).test(this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis)
       if(this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch ===undefined){
            let AdditionalSwitch = {
                    "@Qty": "1",
                    "#text": "None"
                }
          this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch=AdditionalSwitch
          //MellanoxList[0]
           //this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch.Qty="1"
       }
        return (
            <Box pad='small' margin='none' style={{ position: 'relative', width: '100%' }}>                
                <Warning message={Constants.HPECP_WARNING_MESSAGE} isEnabled={!this.props.displayWarning} history={this.props.history}/>
                <Article full={true} margin="none" pad={{ between: 'small' }} style={{ maxHeight: '96%' }} >
                    <Box direction='row' margin="none" pad="none">

                        <ReactTooltip place="right" multiline={true} />
                        <Box direction='row' margin="small" pad="none" style={{ width: '40%' }} >
                            <Form style={{ width: '100%' }}>
                                <FormField className="HWSupport" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Network Speed</Paragraph>
                                    <CircleInformation data-tip='Select the desired network speed for the solution. Top of rack switches will be added to the BOM along with matching network cards and cables.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                </Box>} style={{ marginBottom: '5px' }}>
                                    <Select placeHolder='None' value={this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSpeed"]} onChange={this.NetworkSpeedChage} options={NetworkSpeedList} />
                                </FormField>
                                <FormField className="HWSupport" label="Network Switches Vendor" style={{ marginBottom: '5px' }}>
                                    <Select placeHolder='None' value={this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSwitch"]} onChange={this.AdditionalSwitchChange} options={AdditionalSwitches} />
                                </FormField>
                                 <FormField className="HWSupport" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Additional Network Switch</Paragraph>
                                    {/*<CircleInformation data-tip="Insure your solutions are up and running in your data centers at rapid speeds along with quality assurance. Factory Express is having your solution built, tested and integrated at an HPE Factory, delivered to your Customer's site ready to power " colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                    */}</Box>} style={{ marginBottom: '5px' }}>
                                    <Select placeHolder='None' value={this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch['#text']} onChange={this.AddtnlNtwkSwtchChage} options={MellanoxList} />
                                </FormField> 
                                {/*Condition added by Vinay for hiding No of switches text box when the additional network switch option is None.*/}
                                {this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch['#text']==='None'?'':
                                 <FormField className="HWSupport" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Number of Switches</Paragraph>
                                    {/*<CircleInformation data-tip="Insure your solutions are up and running in your data centers at rapid speeds along with quality assurance. Factory Express is having your solution built, tested and integrated at an HPE Factory, delivered to your Customer's site ready to power " colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /> */}</Box>} error="(1-9)" style={{ marginBottom: '5px' }}>
                                    <TextInput value={this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"]} onDOMChange={(e)=>this.onNumberOfSwitchesChage(e)} onBlur={(e)=>this.onNumberOfSwitchesBlur(e)} />
                                </FormField>} 
                                <FormField className="HWSupport" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Factory Express</Paragraph>
                                    <CircleInformation data-tip="Insure your solutions are up and running in your data centers at rapid speeds along with quality assurance. Factory Express is having your solution built, tested and integrated at an HPE Factory, delivered to your Customer's site ready to power " colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} /></Box>} style={{ marginBottom: '5px' }}>
                                    <Select placeHolder='None' value={this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.FactoryExpress} onChange={this.FactoryExpressChage} options={FactoryExpressList} />
                                </FormField>
                                <FormField className="HWSupport" label={<Box direction='row' style={{ height: '25px' }}><Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Provisioning Type</Paragraph>
                                    <CircleInformation data-tip="Install bare-metal, HPE Ezmeral RE containers or other virtualized solution." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                </Box>} style={{ marginBottom: '5px' }} >
                                    {type}
                                    {/* <Select options ={['Bare metal']} value='Bare metal'/>*/}
                                </FormField>
                                <Box pad="small" margin="small" style={{ marginLeft: '0px', padding: '0px' }}>
                                    <CheckBox className="CheckboxSeparate" label='Consolidate Chassis' style={{ marginRight: '0px' }} checked={ConsolidateChassisValue} onChange={this.ConsolidateChassisChange} />
                                    {this.props.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA ?
                                    <Box style={{paddingTop:'10px' }}> 
                                        <CheckBox className="CheckboxSeparate" label='Configure Nimble Storage' style={{ marginRight: '0px' }}  checked={nimbleStorageChecked} onChange={this.onNimbleStorageChange} />
                                    </Box> :
                                    '' }
                                </Box>
                            </Form>
                        </Box>
                        <Box direction='row' margin="small" pad="{horizontal:'none' ,vertical:'small'}" className="BasicofHardware_licence" style={{ width: '60%' }}>
                            <Form style={{ width: '100%' }}>
                                {displayStorageNetworkSpeed ?
                                <FormField className="HWSupport" label={
                                    <Box direction='row' style={{ height: '25px' }}>
                                        <Paragraph className="HardwareLicensesParagraph" style={{ margin: "0px", }}>Storage Network Speed</Paragraph>
                                        <CircleInformation data-tip='Select the desired storage network speed for the solution. Top of rack switches will be added to the BOM along with matching network cards and cables.' colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px' }} />
                                    </Box>} style={{ marginBottom: '5px' }}>
                                    <Select placeHolder='None' value={this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.StorageNetworkSpeed[Constants.TEXT_ATTRIBUTE]} options={NetworkSpeedList} onChange={this.StorageNetworkSpeedChange}/>
                                </FormField> : '' }
                                <FormField className="HWSupport" label='Max Power per Rack' style={{ marginBottom: '5px' }} error={"(2000-20000)Watts"}>
                                    <TextInput value={this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower} onDOMChange={this.MaxPowerPerRack} onBlur={(e) => this.MaxPowerPerRackBlur(e)} />
                                </FormField>
                                <FormField className="HWSupport" label='Max Weight Per Rack' style={{ marginBottom: '5px' }} error={"(300-5000)Lbs"}>
                                    <TextInput value={this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight} onDOMChange={this.maxWeightPerRack} onBlur={(e) => this.maxWeightPerRackBlur(e)} />
                                </FormField>
                                <FormField className="HWSupport" label=' Rack Units' style={{ marginBottom: '5px' }}>
                                    <Select placeHolder='None' value={this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Rack} options={this.state.PrefereedRackhgtList} onChange={this.onRackHeightChange} />
                                </FormField>
                                <FormField className="HWSupport" label='Preferred Rack' style={{ marginBottom: '5px' }}>
                                    <Select className='Rackdropdown' placeHolder='None' value={this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.RackDescription} options={this.state.preferedRacksList} onChange={this.onRackListChange} />
                                </FormField>
                            </Form>
                        </Box>
                    </Box>
                </Article>
            </Box>

        );
    }
}

const mapStateToProps = (state) => {
    return {

        workload: state.sizerWorkload.workload,
        DefaultLicenceValues: state.sizerWorkload.workload,
        DefaultSolution: state.sizerWorkload.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails,
        Informationicondescription: state.sizerWorkload.sessionDefaults.Sizers.Sizer.InfoIconDescriptions,
        //ActivePartNumbers:state.sizerWorkload.activepartnumbers,
        isLoading: state.sizerWorkload.isLoading,
        SupportedComponents: state.sizerWorkload.supportedList,
        //SupportedComponentsRack:state.sizerWorkload.supportedList,
        // FilteredComps:state.sizerWorkload.filteredComponents,
        activeSession: state.sessions.activeSession,
        ConfigButton: state.sizerWorkload.calbtn,
        displayWarning: state.sizerWorkload.guiState.displayWarning
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        getAllActivePartNumbers: () => {
            dispatch(fetchActiveList());
        },
        getAllFilteredComps: () => {
            dispatch(fetchFilteredComps(GetAllSupportedComponents));
        },
        OnToggleSizeButton: (value) => { dispatch(toggleSizeButton(value)) },
        OnFetchSupportedList: () => {
            dispatch(fetchSupportedList());
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DesignRequirements);



// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/HardWareAndLicenses.js